import { AppEvent } from '@core/modules/event-bus/events/app-event';

export class SidebarOpenedEvent extends AppEvent<void> {
  readonly type = 'sidebar:opened' as const;

  constructor() {
    super(undefined as void);
  }
}

export class SidebarClosedEvent extends AppEvent<void> {
  readonly type = 'sidebar:closed' as const;

  constructor() {
    super(undefined as void);
  }
}

export class SidebarToggledEvent extends AppEvent<void> {
  readonly type = 'sidebar:toggled' as const;

  constructor() {
    super(undefined as void);
  }
}

/**
 * Payload for the SidebarRouteChangedEvent, containing the new active route path.
 */
export interface SidebarRouteChangedPayload {
  /** New active route path */
  route: string;
}

export class SidebarRouteChangedEvent extends AppEvent<SidebarRouteChangedPayload> {
  readonly type = 'sidebar:route-changed' as const;

  constructor(payload: SidebarRouteChangedPayload) {
    super(payload);
  }
}

export const SidebarEvents = {
  Opened: SidebarOpenedEvent,
  Closed: SidebarClosedEvent,
  Toggled: SidebarToggledEvent,
  RouteChanged: SidebarRouteChangedEvent,
} as const;
